<script lang="ts">
    import {Access} from "./jmdb"
    
    export let access: Access
</script>

{#if access == Access.Allow}✅{:else if access == Access.Deny}❌{:else}❔{/if}

